export enum HistoricalCostType {
    Power = "power"
}